import { create } from 'zustand';

interface DoBoxAutomationMenuTriggerState {
  isOpen: boolean;
}

interface DoBoxAutomationMenuTriggerActions {
  open: () => void;
  close: () => void;
}

type DoBoxAutomationMenuTriggerStore = DoBoxAutomationMenuTriggerState &
  DoBoxAutomationMenuTriggerActions;

// Lets a surface outside the DoBox header (the first-run banner's Automations
// tour panel) open the header's DoBoxAutomationMenu popover without reaching
// across the DOM. `open()` is a one-shot pulse: DoBoxAutomationMenu consumes it
// and immediately calls `close()` back, so this never holds the popover open on
// its own — the popover's own internal state does that once triggered.
export const useDoBoxAutomationMenuTriggerStore =
  create<DoBoxAutomationMenuTriggerStore>((set) => ({
    isOpen: false,
    open: () => set({ isOpen: true }),
    close: () => set({ isOpen: false }),
  }));
